import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {Delete as DeleteIcon} from "@mui/icons-material";
import {Datatable} from "../index";
import {ConheceulojaService} from "./conheceuloja.service";
import {useNavigate} from "react-router-dom";
import {changePageTitle} from "../typescript/redux/actions";

export function ConheceulojaList() {

    let navigate = useNavigate();
    const [pageParams, setPageParams] = useState(null);
    const dispatch = useDispatch();

    const findAll = useCallback(async (number, size, sort, filter) => {
        const items = await ConheceulojaService.findAll(number, size, sort, filter);
        setPageParams({
            number: number,
            size: size,
            sort: sort,
            filter: filter,
            items: items
        });
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Como conheceu a Copacubana"));
        findAll(0, parseInt(process.env.REACT_APP_PAGE_SIZE), "id,asc", '').then();
    }, [dispatch, findAll]);

    const editItem = (item) => {
        navigate('/conheceuloja/' + item.id);
    }

    const insertItem = () => {
        navigate('/conheceuloja');
    }

    const deleteItem = (item) => {
        ConheceulojaService.delete(item.id).then(() => {
            findAll(pageParams.number, pageParams.size, pageParams.sort, pageParams.filter).then();
        }).catch(() => {

        })
    }

    const headerOperations = [
        {color: () => "primary", onClick: insertItem, label: () => 'Inserir'}
    ]

    const rowOperations = [
        {color: () => "primary", onClick: deleteItem, label: () => 'Excluir', icon: () => <DeleteIcon/>},
    ]

    return pageParams && (
        <Datatable data={pageParams.items.content} totalData={pageParams.items.totalElements}
                   dataColumnNames={['ID', 'Descrição']}
                   dataColumns={['id', 'descricao']}
                   dataTypes={['number', 'text']}
                   number={pageParams.number} size={pageParams.size} sort={pageParams.sort} filter={pageParams.filter}
                   findAll={findAll}
                   editData={editItem} headerOperations={headerOperations} rowOperations={rowOperations}/>
    );
}